import { render, staticRenderFns } from "./ListAddressbook.vue?vue&type=template&id=23598bbe&"
import script from "./ListAddressbook.vue?vue&type=script&lang=js&"
export * from "./ListAddressbook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports